import * as _ from 'underscore';

export const validators = {
    chartParams: {
        //LL: for customStyles, colorMappingForNumeric:
        customStyles_shouldHaveNames: function (value) {
            var find = _.find<any>(value, (obj) => {
                return obj.name == null || $.trim(obj.name) === '';
            });

            if (find != null) {
                return ['Non-blank Name should be specified for all items'];
            }
        },

        //LL: for customStyles, colorMappingForNumeric:
        customStyles_namesUnique: function (value) {
            var count = _.countBy<any>(
                value,
                //(obj) => { return obj.name || ' '; }
                (obj) => {
                    //LL: allow repeate for "another" items ( = inherited from upper, ex Workspace)
                    if (obj.another === true) return; // key === "undefined"
                    var name = obj.name;
                    if (name != null) {
                        name = $.trim(name);
                    } else {
                        name = ' ';
                    }
                    return name;
                }
            );
            //var find = _.find<any>(
            //    count,
            //    (num) => {
            //        return num > 1;
            //    }
            //);
            var find = _.find<any>(count, (num, key) => {
                if (key === 'undefined') return false;
                return num > 1;
            });
            if (find != null) {
                return ['Names should be different for all items'];
            }
        },

        colorMappingForNumeric_MinMax: function (value) {
            var find = _.find<any>(value, (obj: any) => {
                return obj.scaleMin != null && obj.scaleMax != null && obj.scaleMin > obj.scaleMax;
            });

            if (find != null) {
                return ['Some Scale Values are wrong: "Min" must be <= "Max"'];
            }
        }
    }
};
